import { take, call, put, select, all } from 'redux-saga/effects'
import { apiSaga, formSaga } from './sagas'
import { api, connectionsCache, shareablesCache } from '../../api/api'
import flatten from 'lodash/flatten'
import { normalizeUserCreationError } from '../../util/errorUtils'
import format from 'date-fns/format'
import { pushGTMDataLayer } from '../../util/gtmUtils'
import { logException } from '../../util/errorUtils'
import {
  selectCurrentUser,
  getFriendRequests,
} from '../../redux/modules/selectors'

// ------------------------------------
// Action Types & Creators
// ------------------------------------

export const ADD_FRIEND_REQUEST = 'foodsby/friends/ADD_FRIEND_REQUEST'
export const ADD_FRIEND_REQUEST_SUCCESS =
  'foodsby/friends/ADD_FRIEND_REQUEST_SUCCESS'
export const ADD_FRIEND_REQUEST_FAILURE =
  'foodsby/friends/ADD_FRIEND_REQUEST_FAILURE'

export const LOAD_FRIENDS = 'foodsby/friends/LOAD_FRIENDS'
export const LOAD_FRIENDS_SUCCESS = 'foodsby/friends/LOAD_FRIENDS_SUCCESS'
export const LOAD_FRIENDS_FAILURE = 'foodsby/friends/LOAD_FRIENDS_FAILURE'

export const LOAD_FRIENDS_AT_DATETIME =
  'foodsby/friends/LOAD_FRIENDS_AT_DATETIME'
export const LOAD_FRIENDS_AT_DATETIME_SUCCESS =
  'foodsby/friends/LOAD_FRIENDS_AT_DATETIME_SUCCESS'
export const LOAD_FRIENDS_AT_DATETIME_FAILURE =
  'foodsby/friends/LOAD_FRIENDS_AT_DATETIME_FAILURE'

export const LOAD_FRIENDS_FAVORITES = 'foodsby/friends/LOAD_FRIENDS_FAVORITES'
export const LOAD_FRIENDS_FAVORITES_SUCCESS =
  'foodsby/friends/LOAD_FRIENDS_FAVORITES_SUCCESS'
export const LOAD_FRIENDS_FAVORITES_FAILURE =
  'foodsby/friends/LOAD_FRIENDS_FAVORITES_FAILURE'

export const DELETE_FRIEND = 'foodsby/friends/DELETE_FRIEND'
export const DELETE_FRIEND_SUCCESS = 'foodsby/friends/DELETE_FRIEND_SUCCESS'
export const DELETE_FRIEND_FAILURE = 'foodsby/friends/DELETE_FRIEND_FAILURE'

export const FRIEND_REQUEST_RESPONSE = 'foodsby/friends/FRIEND_REQUEST_RESPONSE'
export const FRIEND_REQUEST_RESPONSE_SUCCESS =
  'foodsby/friends/FRIEND_REQUEST_RESPONSE_SUCCESS'
export const FRIEND_REQUEST_RESPONSE_SUCCESS_ACKNOWLEDGED =
  'foodsby/friends/FRIEND_REQUEST_RESPONSE_SUCCESS_ACKNOWLEDGED'
export const FRIEND_REQUEST_RESPONSE_FAILURE =
  'foodsby/friends/FRIEND_REQUEST_RESPONSE_FAILURE'

export const GET_INCOMING_FRIEND_REQUESTS =
  'foodsby/friends/GET_INCOMING_FRIEND_REQUESTS'
export const GET_INCOMING_FRIEND_REQUESTS_SUCCESS =
  'foodsby/friends/GET_INCOMING_FRIEND_REQUESTS_SUCCESS'
export const GET_INCOMING_FRIEND_REQUESTS_FAILURE =
  'foodsby/friends/GET_INCOMING_FRIEND_REQUESTS_FAILURE'

export const GET_OUTGOING_FRIEND_REQUESTS =
  'foodsby/friends/GET_OUTGOING_FRIEND_REQUESTS'
export const GET_OUTGOING_FRIEND_REQUESTS_SUCCESS =
  'foodsby/friends/GET_OUTGOING_FRIEND_REQUESTS_SUCCESS'
export const GET_OUTGOING_FRIEND_REQUESTS_FAILURE =
  'foodsby/friends/GET_OUTGOING_FRIEND_REQUESTS_FAILURE'

export const GET_FRIEND_REQUEST_COUNT =
  'foodsby/friends/GET_FRIEND_REQUEST_COUNT'
export const GET_FRIEND_REQUEST_COUNT_SUCCESS =
  'foodsby/friends/GET_FRIENDS_REQUEST_COUNT_SUCCESS'
export const GET_FRIEND_REQUEST_COUNT_FAILURE =
  'foodsby/friends/GET_FRIENDS_REQUEST_COUNT_FAILURE'

export const CANCEL_OUTGOING_FRIEND_REQUEST =
  'foodsby/friends/CANCEL_OUTGOING_FRIEND_REQUEST'
export const CANCEL_OUTGOING_FRIEND_REQUEST_SUCCESS =
  'foodsby/friends/CANCEL_OUTGOING_FRIEND_REQUEST_SUCCESS'
export const CANCEL_OUTGOING_FRIEND_REQUEST_FAILURE =
  'foodsby/friends/CANCEL_OUTGOING_FRIEND_REQUEST_FAILURE'

export const GET_FRIENDS_ORDERS = 'foodsby/friends/GET_FRIENDS_ORDERS'
export const GET_FRIENDS_ORDERS_SUCCESS =
  'foodsby/friends/GET_FRIENDS_ORDERS_SUCCESS'
export const GET_FRIENDS_ORDERS_FAILURE =
  'foodsby/friends/GET_FRIENDS_ORDERS_FAILURE'

export const GET_AUTOCOMPLETE_SUGGESTIONS =
  'foodsby/friends/GET_AUTOCOMPLETE_SUGGESTIONS'
export const GET_AUTOCOMPLETE_SUGGESTIONS_SUCCESS =
  'foodsby/friends/GET_AUTOCOMPLETE_SUGGESTIONS_SUCCESS'
export const GET_AUTOCOMPLETE_SUGGESTIONS_FAILURE =
  'foodsby/friends/GET_AUTOCOMPLETE_SUGGESTIONS_FAILURE'
export const CLEAR_AUTOCOMPLETE_SUGGESTIONS =
  'foodsby/friends/CLEAR_AUTOCOMPLETE_SUGGESTIONS'
export const CLEAR_FRIENDS_AT_DATETIME =
  'foodsby/friends/CLEAR_FRIENDS_AT_DATETIME'

export const GET_SUGGESTED_FRIENDS = 'foodsby/friends/GET_SUGGESTED_FRIENDS'
export const GET_SUGGESTED_FRIENDS_SUCCESS =
  'foodsby/friends/GET_SUGGESTED_FRIENDS_SUCCESS'
export const GET_SUGGESTED_FRIENDS_FAILURE =
  'foodsby/friends/GET_SUGGESTED_FRIENDS_FAILURE'
export const CLEAR_SUGGESTED_FRIENDS = 'foodsby/friends/CLEAR_SUGGESTED_FRIENDS'

export const REFERRAL_SUCCESS = 'foodsby/friends/REFERRAL_SUCCESS'
export const REFERRAL_ACKNOWLEDGE = 'foodsby/friends/REFERRAL_ACKNOWLEDGE'

export const addFriendStart = user => {
  return {
    type: ADD_FRIEND_REQUEST,
    payload: { user },
  }
}

export const addFriendRequestSuccess = response => {
  return {
    type: ADD_FRIEND_REQUEST_SUCCESS,
    payload: { response },
  }
}

export const addFriendRequestFailure = error => {
  return {
    type: ADD_FRIEND_REQUEST_FAILURE,
    error,
  }
}

export const loadFriendsStart = (options = {}) => {
  return {
    type: LOAD_FRIENDS,
    payload: { options },
  }
}

export const loadFriendsSuccess = friends => {
  return {
    type: LOAD_FRIENDS_SUCCESS,
    payload: { friends },
  }
}

export const loadFriendsFailure = error => {
  return {
    type: LOAD_FRIENDS_FAILURE,
    error,
  }
}

export const loadFriendsAtDateTimeStart = (datetime, options = {}) => {
  return {
    type: LOAD_FRIENDS_AT_DATETIME,
    payload: { datetime, options },
  }
}

export const loadFriendsAtDateTimeSuccess = friends => {
  return {
    type: LOAD_FRIENDS_AT_DATETIME_SUCCESS,
    payload: { friends },
  }
}

export const loadFriendsAtDateTimeFailure = error => {
  return {
    type: LOAD_FRIENDS_AT_DATETIME_FAILURE,
    error,
  }
}

export const clearFriendsAtDateTime = () => {
  return {
    type: CLEAR_FRIENDS_AT_DATETIME,
  }
}

export const loadFriendsFavorites = (menuItemId, options = {}) => {
  return {
    type: LOAD_FRIENDS_FAVORITES,
    payload: { menuItemId, options },
  }
}

export const loadFriendsFavoritesSuccess = friendsFavorites => {
  return {
    type: LOAD_FRIENDS_FAVORITES_SUCCESS,
    payload: { friendsFavorites },
  }
}

export const loadFriendsFavoritesFailure = error => {
  return {
    type: LOAD_FRIENDS_FAVORITES_FAILURE,
    error,
  }
}

export const getIncomingFriendRequests = (type, options = {}) => {
  return {
    type: GET_INCOMING_FRIEND_REQUESTS,
    payload: { type, options },
  }
}

export const getIncomingFriendRequestsSuccess = response => {
  return {
    type: GET_INCOMING_FRIEND_REQUESTS_SUCCESS,
    payload: { response },
  }
}

export const getIncomingFriendRequestsFailure = error => {
  return {
    type: GET_INCOMING_FRIEND_REQUESTS_FAILURE,
    error,
  }
}

export const getOutgoingFriendRequests = (type, options = {}) => {
  return {
    type: GET_OUTGOING_FRIEND_REQUESTS,
    payload: { type, options },
  }
}

export const getOutgoingFriendRequestsSuccess = response => {
  return {
    type: GET_OUTGOING_FRIEND_REQUESTS_SUCCESS,
    payload: { response },
  }
}

export const getOutgoingFriendRequestsFailure = error => {
  return {
    type: GET_OUTGOING_FRIEND_REQUESTS_FAILURE,
    error,
  }
}

export const getFriendRequestCount = (type, options = {}) => {
  return {
    type: GET_FRIEND_REQUEST_COUNT,
    payload: { type, options },
  }
}

export const getFriendRequestCountSuccess = response => {
  return {
    type: GET_FRIEND_REQUEST_COUNT_SUCCESS,
    payload: { response },
  }
}

export const getFriendRequestCountFailure = error => {
  return {
    type: GET_FRIEND_REQUEST_COUNT_FAILURE,
    error,
  }
}

export const friendRequestResponse = response => {
  return {
    type: FRIEND_REQUEST_RESPONSE,
    payload: {
      response,
      action: response.action,
    },
  }
}

export const friendRequestResponseSuccess = () => {
  return {
    type: FRIEND_REQUEST_RESPONSE_SUCCESS,
  }
}

export const acknowledgeSuccessfulFriendRequest = () => {
  return {
    type: FRIEND_REQUEST_RESPONSE_SUCCESS_ACKNOWLEDGED,
  }
}

export const friendRequestResponseFailure = error => {
  return {
    type: FRIEND_REQUEST_RESPONSE_FAILURE,
    error,
  }
}

export const cancelOutgoingFriendRequest = id => {
  return {
    type: CANCEL_OUTGOING_FRIEND_REQUEST,
    payload: { id },
  }
}

export const cancelOutgoingFriendRequestSuccess = () => {
  return {
    type: CANCEL_OUTGOING_FRIEND_REQUEST_SUCCESS,
  }
}

export const cancelOutgoingFriendRequestFailure = error => {
  return {
    type: CANCEL_OUTGOING_FRIEND_REQUEST_FAILURE,
    error,
  }
}

export const deleteCurrentFriend = id => {
  return {
    type: DELETE_FRIEND,
    payload: { id },
  }
}

export const deleteCurrentFriendSuccess = () => {
  return {
    type: DELETE_FRIEND_SUCCESS,
  }
}

export const deleteCurrentFriendFailure = error => {
  return {
    type: DELETE_FRIEND_FAILURE,
    error,
  }
}

export const getFriendsOrdersStart = (date, location = '', options = {}) => {
  return {
    type: GET_FRIENDS_ORDERS,
    payload: { date, location, options },
  }
}

export const getFriendsOrdersSuccess = response => {
  return {
    type: GET_FRIENDS_ORDERS_SUCCESS,
    payload: { response },
  }
}

export const getFriendsOrdersFailure = error => {
  return {
    type: GET_FRIENDS_ORDERS_FAILURE,
    error,
  }
}

export const getAutocompleteFriendsStart = filterKey => {
  return {
    type: GET_AUTOCOMPLETE_SUGGESTIONS,
    payload: { filterKey },
  }
}

export const getAutocompleteFriendsSuccess = suggestions => {
  return {
    type: GET_AUTOCOMPLETE_SUGGESTIONS_SUCCESS,
    payload: { suggestions },
  }
}

export const getAutocompleteFriendsFailure = error => {
  return {
    type: GET_AUTOCOMPLETE_SUGGESTIONS_FAILURE,
    error,
  }
}

export const clearAutocompleteSuggestions = () => {
  return {
    type: CLEAR_AUTOCOMPLETE_SUGGESTIONS,
  }
}

export const getSuggestedFriendsStart = () => {
  return {
    type: GET_SUGGESTED_FRIENDS,
  }
}

export const getSuggestedFriendsSuccess = suggestions => {
  return {
    type: GET_SUGGESTED_FRIENDS_SUCCESS,
    payload: { suggestions },
  }
}

export const getSuggestedFriendsFailure = err => {
  return {
    type: GET_SUGGESTED_FRIENDS_FAILURE,
    error: err,
  }
}

export const clearSuggestedFriends = () => {
  return {
    type: CLEAR_SUGGESTED_FRIENDS,
  }
}

export const confirmReferralSuccess = redemptionResult => {
  return {
    type: REFERRAL_SUCCESS,
    payload: { redemptionResult },
  }
}

export const acknowledgeReferral = () => {
  return {
    type: REFERRAL_ACKNOWLEDGE,
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [ADD_FRIEND_REQUEST]: (state, action) => {
    return {
      ...state,
      success: undefined,
      isAddingFriends: true,
      sendFriendRequestError: undefined,
    }
  },
  [ADD_FRIEND_REQUEST_SUCCESS]: (state, action) => {
    const response = action.payload.response.type
    return {
      ...state,
      success: response !== 'FRIENDS',
      isAddingFriends: false,
      sendFriendRequestError:
        response === 'FRIENDS'
          ? 'You are already friends with that person'
          : undefined,
    }
  },
  [ADD_FRIEND_REQUEST_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error)
    return {
      ...state,
      success: undefined,
      isAddingFriends: false,
      sendFriendRequestError: error,
    }
  },
  [LOAD_FRIENDS]: state => {
    return {
      ...state,
      success: undefined,
      isLoadingFriends: true,
      loadFriendsError: undefined,
      sendFriendRequestError: undefined,
      friendRequestLoadingError: undefined,
    }
  },
  [LOAD_FRIENDS_SUCCESS]: (state, action) => {
    const friends = action.payload.friends.content
    return {
      ...state,
      isLoadingFriends: false,
      friends,
    }
  },
  [LOAD_FRIENDS_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriends: false,
      loadFriendsError: error,
    }
  },
  [LOAD_FRIENDS_AT_DATETIME]: state => {
    return {
      ...state,
      isLoadingFriendsAtDatetime: true,
    }
  },
  [LOAD_FRIENDS_AT_DATETIME_SUCCESS]: (state, action) => {
    const friends = action.payload.friends.content
    return {
      ...state,
      isLoadingFriendsAtDatetime: false,
      friendsAtOrderDelivered: friends.map(friend => friend.userId),
    }
  },
  [LOAD_FRIENDS_AT_DATETIME_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriendsAtDatetime: false,
      loadFriendsDateTimeError: error,
    }
  },
  [CLEAR_FRIENDS_AT_DATETIME]: state => {
    return {
      ...state,
      friendsAtOrderDelivered: undefined,
    }
  },
  [LOAD_FRIENDS_FAVORITES]: state => {
    return {
      ...state,
      isLoadingFavorites: true,
      loadFriendsFavoritesError: undefined,
    }
  },
  [LOAD_FRIENDS_FAVORITES_SUCCESS]: (state, action) => {
    const { friendsFavorites } = action.payload
    return {
      ...state,
      isLoadingFavorites: false,
      friendsFavorites,
    }
  },
  [LOAD_FRIENDS_FAVORITES_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFavorites: false,
      loadFriendsFavoritesError: error,
    }
  },
  [GET_INCOMING_FRIEND_REQUESTS]: state => {
    return {
      ...state,
      isLoadingFriendRequests: true,
    }
  },
  [GET_INCOMING_FRIEND_REQUESTS_SUCCESS]: (state, action) => {
    const incomingFriendRequests = action.payload.response.content
    return {
      ...state,
      isLoadingFriendRequests: false,
      incomingFriendRequests,
    }
  },
  [GET_INCOMING_FRIEND_REQUESTS_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriendRequests: false,
      friendRequestLoadingError: error,
    }
  },
  [GET_OUTGOING_FRIEND_REQUESTS]: state => {
    return {
      ...state,
      isLoadingFriendRequests: true,
    }
  },
  [GET_OUTGOING_FRIEND_REQUESTS_SUCCESS]: (state, action) => {
    const outgoingFriendRequests = action.payload.response.content
    return {
      ...state,
      isLoadingFriendRequests: false,
      outgoingFriendRequests,
    }
  },
  [GET_OUTGOING_FRIEND_REQUESTS_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriendRequests: false,
      friendRequestLoadingError: error,
    }
  },
  [GET_FRIEND_REQUEST_COUNT]: state => {
    return {
      ...state,
      isLoadingRequestCount: true,
    }
  },
  [GET_FRIEND_REQUEST_COUNT_SUCCESS]: (state, action) => {
    const requestCount = action.payload.response
    return {
      ...state,
      isLoadingRequestCount: false,
      requestCount,
    }
  },
  [GET_FRIEND_REQUEST_COUNT_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingRequestCount: false,
      requestCountError: error,
    }
  },
  [FRIEND_REQUEST_RESPONSE]: (state, action) => {
    return {
      ...state,
      isRespondingToFriendRequest: true,
      friendRequestSuccess: undefined,
      friendRequestResponseType: action.payload.action,
    }
  },
  [FRIEND_REQUEST_RESPONSE_SUCCESS]: (state, action) => {
    return {
      ...state,
      isRespondingToFriendRequest: false,
      friendRequestSuccess: true,
    }
  },
  [FRIEND_REQUEST_RESPONSE_SUCCESS_ACKNOWLEDGED]: state => {
    return {
      ...state,
      friendRequestSuccess: undefined,
    }
  },
  [FRIEND_REQUEST_RESPONSE_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      friendRequestResponseError: error,
      isRespondingToFriendRequest: false,
    }
  },
  [CANCEL_OUTGOING_FRIEND_REQUEST]: state => {
    return {
      ...state,
      isCancelingOutgoingRequest: true,
    }
  },
  [CANCEL_OUTGOING_FRIEND_REQUEST_SUCCESS]: (state, action) => {
    return {
      ...state,
      isCancelingOutgoingRequest: false,
    }
  },
  [CANCEL_OUTGOING_FRIEND_REQUEST_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isCancelingOutgoingRequest: false,
      cancelOutgoingRequestError: error,
    }
  },
  [DELETE_FRIEND]: state => {
    return {
      ...state,
      isDeletingFriend: true,
    }
  },
  [DELETE_FRIEND_SUCCESS]: state => {
    return {
      ...state,
      isDeletingFriend: false,
    }
  },
  [DELETE_FRIEND_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isDeletingFriend: false,
      deletingFriendError: error,
    }
  },
  [GET_FRIENDS_ORDERS]: state => {
    return {
      ...state,
      isLoadingFriendsOrders: true,
    }
  },
  [GET_FRIENDS_ORDERS_SUCCESS]: (state, action) => {
    let friendNotOrdered
    let friendHasOrdered = []
    let friendsOrderCount = []

    if (action.payload.response) {
      action.payload.response.forEach(dropoff => {
        if (dropoff.dropoffId === null) {
          friendNotOrdered = dropoff.friendsOrders
        } else if (dropoff.dropoffId !== null) {
          friendHasOrdered.push(dropoff)
          friendsOrderCount.push(dropoff.friendsOrders)
        }
      })
    }
    friendsOrderCount = flatten(friendsOrderCount)
    return {
      ...state,
      friendsOrdersError: undefined,
      isLoadingFriendsOrders: false,
      friendNotOrdered,
      friendHasOrdered,
      friendsOrderCount,
    }
  },
  [GET_FRIENDS_ORDERS_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriendsOrders: false,
      friendsOrdersError: error,
    }
  },
  [GET_AUTOCOMPLETE_SUGGESTIONS]: (state, action) => {
    return {
      ...state,
      isLoadingAutocomplete: true,
    }
  },
  [GET_AUTOCOMPLETE_SUGGESTIONS_SUCCESS]: (state, action) => {
    let {
      payload: { suggestions },
    } = action
    suggestions = suggestions.map(s => {
      return {
        value: s.userId,
        label: `${s.firstName} ${s.lastName}`,
        firstName: s.firstName,
        lastName: s.lastName,
        avatarId: s.avatarId,
      }
    })
    return {
      ...state,
      isLoadingAutocomplete: false,
      suggestions,
    }
  },
  [GET_AUTOCOMPLETE_SUGGESTIONS_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isLoadingAutocomplete: false,
      autoCompleteError: error,
      suggestions: [],
    }
  },
  [CLEAR_AUTOCOMPLETE_SUGGESTIONS]: (state, action) => {
    return {
      ...state,
      suggestions: [],
    }
  },
  [GET_SUGGESTED_FRIENDS]: (state, action) => {
    return {
      ...state,
      isLoadingSuggestedFriends: true,
    }
  },
  [GET_SUGGESTED_FRIENDS_SUCCESS]: (state, action) => {
    const { suggestions } = action.payload
    const suggestedFriends =
      suggestions && suggestions.content ? suggestions.content : []
    return {
      ...state,
      isLoadingSuggestedFriends: false,
      suggestedFriends: suggestedFriends,
    }
  },
  [GET_SUGGESTED_FRIENDS_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isLoadingSuggestedFriends: false,
      suggestedFriends: undefined,
      suggestedFriendsError: error,
    }
  },
  [CLEAR_SUGGESTED_FRIENDS]: (state, action) => {
    return {
      ...state,
      suggestedFriends: undefined,
    }
  },
  [REFERRAL_SUCCESS]: (state, action) => {
    const { redemptionResult } = action.payload
    return {
      ...state,
      referralSuccess: true,
      redemptionResult,
    }
  },
  [REFERRAL_ACKNOWLEDGE]: (state, action) => {
    return {
      ...state,
      referralSuccess: undefined,
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  favorites: [],
  suggestions: [],
}

export default function friends(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------

export function* watchSendNewFriendRequest() {
  while (true) {
    const {
      payload: { user },
    } = yield take(ADD_FRIEND_REQUEST)
    const currentUser = yield select(selectCurrentUser)
    try {
      pushGTMDataLayer({
        event: 'friend_request',
        userId: currentUser.userId,
      })
    } catch (ex) {
      logException(ex)
    }
    const value = user.email || user
    if (typeof value === 'number') {
      yield call(
        formSaga,
        'friendRequestForm',
        addNewFriendRequestById,
        [value],
        addFriendRequestSuccess,
        addFriendRequestFailure,
      )
    } else {
      yield call(
        formSaga,
        'friendRequestForm',
        addNewFriendRequest,
        [user],
        addFriendRequestSuccess,
        addFriendRequestFailure,
      )
    }
  }
}

export function* watchLoadCurrentFriends() {
  while (true) {
    const {
      payload: { options },
    } = yield take(LOAD_FRIENDS)
    yield call(
      apiSaga,
      getMyFriends,
      [options],
      loadFriendsSuccess,
      loadFriendsFailure,
    )
  }
}

export function* watchLoadCurrentFriendsAtDateTime() {
  while (true) {
    const {
      payload: { datetime, options },
    } = yield take(LOAD_FRIENDS_AT_DATETIME)
    const utcDate = new Date(datetime).toISOString()
    const queryDate = format(utcDate, 'YYYY-MM-DDTHH:mm:ss:SSS')
    yield call(
      apiSaga,
      getMyFriendsAtDate,
      [queryDate, options],
      loadFriendsAtDateTimeSuccess,
      loadFriendsAtDateTimeFailure,
    )
  }
}

export function* watchLoadFriendsSuccess() {
  while (true) {
    yield take(LOAD_FRIENDS_SUCCESS)
    yield put(getIncomingFriendRequests('INCOMING', { forceUpdate: true }))
    yield put(getOutgoingFriendRequests('OUTGOING', { forceUpdate: true }))
    yield put(getFriendRequestCount('INCOMING', { forceUpdate: true }))
  }
}

export function* watchLoadIncomingFriendRequests() {
  while (true) {
    const {
      payload: { type, options },
    } = yield take(GET_INCOMING_FRIEND_REQUESTS)
    yield call(
      apiSaga,
      getMyFriendRequests,
      [type, options],
      getIncomingFriendRequestsSuccess,
      getIncomingFriendRequestsFailure,
    )
  }
}

export function* watchLoadOutgoingFriendRequests() {
  while (true) {
    const {
      payload: { type, options },
    } = yield take(GET_OUTGOING_FRIEND_REQUESTS)
    yield call(
      apiSaga,
      getMyFriendRequests,
      [type, options],
      getOutgoingFriendRequestsSuccess,
      getOutgoingFriendRequestsFailure,
    )
  }
}

export function* watchLoadFriendsFavorites() {
  while (true) {
    const {
      payload: { menuItemId, options },
    } = yield take(LOAD_FRIENDS_FAVORITES)
    yield call(
      apiSaga,
      friendsFavorites,
      [menuItemId, options],
      loadFriendsFavoritesSuccess,
      loadFriendsFavoritesFailure,
    )
  }
}

export function* watchRespondingToFriendRequests() {
  while (true) {
    const {
      payload: { response },
    } = yield take(FRIEND_REQUEST_RESPONSE)
    yield call(
      apiSaga,
      respondToFriendRequest,
      [response],
      friendRequestResponseSuccess,
      friendRequestResponseFailure,
    )
  }
}

export function* watchFriendRequestResponseSuccess() {
  while (true) {
    const { type, payload } = yield take([
      ADD_FRIEND_REQUEST_SUCCESS,
      FRIEND_REQUEST_RESPONSE_SUCCESS,
    ])
    if (
      type === FRIEND_REQUEST_RESPONSE_SUCCESS ||
      (payload &&
        payload.response &&
        payload.response.type &&
        payload.response.type !== 'FRIENDS')
    ) {
      yield put(loadFriendsStart({ forceUpdate: true }))
    }
  }
}

export function* watchLoadFriendRequestCount() {
  while (true) {
    const {
      payload: { type, options },
    } = yield take(GET_FRIEND_REQUEST_COUNT)
    yield call(
      apiSaga,
      getMyFriendRequestCount,
      [type, options],
      getFriendRequestCountSuccess,
      getFriendRequestCountFailure,
    )
  }
}

export function* watchLoadFriendRequestCountSuccess() {
  while (true) {
    const [
      {
        payload: { response },
      },
    ] = yield all([
      take(GET_FRIEND_REQUEST_COUNT_SUCCESS),
      take(GET_INCOMING_FRIEND_REQUESTS_SUCCESS),
    ])
    const incomingFriendRequests = yield select(getFriendRequests)
    const incomingFriendRequestsCount =
      incomingFriendRequests && incomingFriendRequests.length
    if (response && response > 0 && response !== incomingFriendRequestsCount) {
      yield put(getIncomingFriendRequests('INCOMING', { forceUpdate: true }))
    }
  }
}

export function* watchDeleteFriend() {
  while (true) {
    const {
      payload: { id },
    } = yield take(DELETE_FRIEND)
    yield call(
      apiSaga,
      deleteFriend,
      [id],
      deleteCurrentFriendSuccess,
      deleteCurrentFriendFailure,
    )
    yield put(loadFriendsStart({ forceUpdate: true }))
  }
}

export function* watchCancelOutgoingRequest() {
  while (true) {
    const {
      payload: { id },
    } = yield take(CANCEL_OUTGOING_FRIEND_REQUEST)
    yield call(
      apiSaga,
      cancelOutgoingRequest,
      [id],
      cancelOutgoingFriendRequestSuccess,
      cancelOutgoingFriendRequestFailure,
    )
    yield put(loadFriendsStart({ forceUpdate: true }))
  }
}

export function* watchGetFriendsOrders() {
  while (true) {
    const {
      payload: { date, location },
    } = yield take(GET_FRIENDS_ORDERS)
    yield call(
      apiSaga,
      getFriendsOrders,
      [date, location],
      getFriendsOrdersSuccess,
      getFriendsOrdersFailure,
    )
  }
}

export function* watchGetAutocomplete() {
  while (true) {
    const {
      payload: { filterKey },
    } = yield take(GET_AUTOCOMPLETE_SUGGESTIONS)
    yield call(
      apiSaga,
      getAutocompleteFriends,
      [filterKey],
      getAutocompleteFriendsSuccess,
      getAutocompleteFriendsFailure,
    )
  }
}

export function* watchGetSuggestedFriends() {
  while (true) {
    yield take(GET_SUGGESTED_FRIENDS)
    yield call(
      apiSaga,
      getSuggestedFriends,
      [],
      getSuggestedFriendsSuccess,
      getSuggestedFriendsFailure,
    )
  }
}

// ------------------------------------
// APIs
// ------------------------------------

export const addNewFriendRequest = email =>
  api.post(`/api/v1/connections/friendships`, email)

export const addNewFriendRequestById = id =>
  api.post(`/api/v1/connections/friendships/${id}`)

export const getMyFriends = (options = {}) =>
  api.get(`/api/v1/connections/friends`, null, {
    cache: connectionsCache,
    ...options,
  })

export const getMyFriendsAtDate = (date, options = {}) =>
  api.get(`/api/v1/connections/friends?atDateTime=${date}`, null, {
    cache: connectionsCache,
    ...options,
  })

export const getMyFriendRequests = (type, options = {}) =>
  api.get(`/api/v1/connections/friendships/requests?direction=${type}`, null, {
    cache: connectionsCache,
    ...options,
  })

export const getMyFriendRequestCount = (type, options = {}) =>
  api.get(
    `/api/v1/connections/friendships/requests/count?direction=${type}`,
    null,
    { cache: connectionsCache, ...options },
  )

export const respondToFriendRequest = response =>
  api.patch(`/api/v1/connections/friendships`, response)

export const deleteFriend = id =>
  api.delete(`/api/v1/connections/friendships/${id}`)

export const cancelOutgoingRequest = id =>
  api.delete(`/api/v1/connections/friendships/requests/${id}`)

export const getFriendsOrders = (date, location, options = {}) =>
  api.get(
    `/api/v2/connections/friends/orders?date=${date}&location=${location}`,
    null,
    { cache: connectionsCache, ...options },
  )

export const friendsFavorites = (menuItemId, options = {}) =>
  api.get(
    `/api/v1/connections/friends-favorites?menuItemId=${menuItemId}`,
    null,
    { cache: connectionsCache, ...options },
  )

export const getAutocompleteFriends = (filterKey = '') =>
  api.get(
    `/api/v1/connections/friends/autocomplete?filterKey=${filterKey}`,
    null,
    { cache: connectionsCache },
  )

export const getSuggestedFriends = (size = 9, page = 0) =>
  api.get(
    `/api/v1/connections/friends/second-connections?size=${size}&page=${page}`,
  )

export const referralGet = () =>
  api.get(`/api/v1/shareables/referrals`, null, { cache: shareablesCache })

export const referralGetWithEnabledDetails = () =>
  api.get(`/api/v1/shareables/referrals/enabledDetails`, null, {
    cache: shareablesCache,
  })

export const referralGetDetails = referralCode =>
  api.get(`/api/v1/shareables/referrals/${referralCode}`, null, {
    cache: shareablesCache,
  })

export const referralsGetPreviouslyRedeemed = () =>
  api.get('/api/v1/shareables/referrals/history/redemptions')

export const referralRedeem = referralCode =>
  api.post(`/api/v2/shareables/referrals/${referralCode}/redemptions`)
